import './Loader.css';

const Loader = () => {
    return (
        <>
            <div className='Loader'>
                <div className="lds-facebook"><div></div><div></div><div></div></div>
            </div>
        </>
    )
}

export default Loader;